import PropTypes from 'prop-types';
import React, { memo } from 'react';
import Image from '../Image/index.js';
import LinkIcon from '../LinkIcon/index.js';
import Link from '../Link/index.js';
import PartnerLink from '../PartnerLink/index.js';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const renderImage = (image, imageHeight, imageWidth) => /*#__PURE__*/_jsx(Image, {
  ...image,
  height: imageHeight,
  width: imageWidth
});
function LinkTile(_ref) {
  let {
    className,
    image = {},
    imageHeight = 30,
    imageWidth,
    link = {},
    linkVisible = true,
    onTileClick,
    onLinkClick,
    title,
    tileVisible = true,
    isProductTile,
    ...rest
  } = _ref;
  const content = title || link.label;
  let linkedText;
  const linkedTextClassNames = 'padding-right-2';
  const linkedTextProps = {
    rel: 'nofollow noopener',
    target: '_blank',
    ...link,
    onClick: onLinkClick
  };
  const {
    offsite,
    partner
  } = link;
  delete linkedTextProps.offsite;
  if (offsite) {
    const {
      label,
      ...restLinkedProps
    } = linkedTextProps;
    linkedText = /*#__PURE__*/_jsx(LinkIcon, {
      ...restLinkedProps,
      "aria-describedby": "srp-external-link",
      className: linkedTextClassNames,
      glyph: "offsite",
      undecorated: true,
      children: label
    });
  } else if (partner) {
    linkedText = /*#__PURE__*/_jsx(PartnerLink, {
      ...linkedTextProps,
      className: linkedTextClassNames
    });
  } else {
    linkedText = /*#__PURE__*/_jsx(Link, {
      ...linkedTextProps,
      undecorated: true,
      className: linkedTextClassNames
    });
  }
  const imageProps = {
    ...linkedTextProps,
    alt: title,
    ...(!linkVisible && {
      'aria-label': content
    }),
    onClick: onTileClick || onLinkClick
  };
  if (!image.title) {
    image.title = content;
  }

  // images should always have alt, even if it is empty string
  // the image is redundant if the text link is visible, however
  if (!image.alt) {
    image.alt = linkVisible ? '' : content;
  }

  // This appears to be coming from several listing services but I can't find any usage of it
  // Removing from the rest spread for now to clean up DOM warnings
  // We should remove this from the response if it is not being used.
  delete rest.tileType;
  const renderPartnerLinkImage = () => {
    delete imageProps.label;
    delete imageProps.partner;
    return /*#__PURE__*/_jsx(PartnerLink, {
      ...imageProps,
      "data-cmp": "partnerLinkTile",
      children: renderImage(image, imageHeight, imageWidth)
    });
  };
  delete imageProps.partner;
  const linkImage = link.partner || isProductTile ? renderPartnerLinkImage() : /*#__PURE__*/_jsx("a", {
    ...imageProps,
    children: renderImage(image, imageHeight, imageWidth)
  });
  return /*#__PURE__*/_jsxs("div", {
    "data-cmp": "linkTile",
    className: className,
    ...rest,
    children: [linkVisible && linkedText, tileVisible && image.src && linkImage]
  });
}
export default /*#__PURE__*/memo(LinkTile);